import styles from './SmallLoadingIcon.module.scss'

function SmallLoadingIcon(props) {
  const { className = null, style = {} } = props
  return (
    <div className={`${className} ${styles['loading-wrapper']}`} style={style}>
      <div className={styles['dot--flashing']} />
    </div>
  )
}

export default SmallLoadingIcon
